import React from "react";
import { css } from "styled-components";
import { IColumnDefinition, IItem } from "../types";
import { Checkbox } from "../../form";

const TableCellClassName = "select-column";

export const SelectTableCellStyle = css`
    &.${TableCellClassName} {
        position: relative;

        label {
            position: static;
            display: flex;

            ::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }
    }
`;

const selectColumn: IColumnDefinition<IItem, "select"> = {
    id: "select",
    size: 40,
    maxSize: 40,
    minSize: 40,
    header: header => {
        const allSelected = header.table.getIsAllRowsSelected();
        const someSelected = header.table.getIsSomeRowsSelected();

        return (
            <Checkbox
                trackName="select-all"
                checked={allSelected || someSelected}
                indeterminate={someSelected}
                onChange={header.table.toggleAllRowsSelected}
            />
        );
    },
    cell: ({ row }) => {
        return (
            <Checkbox
                trackName="select"
                checked={row.getIsSelected()}
                onChange={row.toggleSelected}
                disabled={!row.getCanSelect()}
            />
        );
    },
    meta: {
        actions: true,
        cellClassName: TableCellClassName,
        headerClassName: TableCellClassName
    }
};

export default selectColumn;
